<section dir="ltr" class="bg-white dark:bg-gray-900 h-full px-4 sm:px-0">
  <div>
    <div
      class="pb-8 md:py-8 px-4 mx-auto mb-auto max-w-screen-xl text-center"
    >
      <h1
        class="mb-4 mt-[calc(1rem+2.05vh)] font-extrabold tracking-tight leading-none text-gray-900 dark:text-white text-6xl md:text-[min(10vw,5vw)]"
      >
        Almanjobs
      </h1>
      <p
        class="mb-8 font-normal text-gray-500 sm:px-16 lg:px-48 dark:text-gray-400 text-md md:text-[min(6vw,2vw)]"
      >
        {{ 'HOME.HERO.TEXT' | translate }}
      </p>
      <div
        class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0"
        dir="ltr"
      >
        <a
          [routerLink]="['jobs']"
          class="inline-flex justify-center items-center py-2 px-4 lg:py-3 lg:px-5 text-sm lg:text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 cursor-pointer focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900"
        >
          {{ 'HOME.HERO.FIND-JOBS' | translate }}
          <ng-icon
            name="heroArrowRightSolid"
            class="ltr:ml-2 rtl:rotate-180 rtl:mr-2"
          ></ng-icon>
        </a>
        <!-- <a
          [routerLink]="['about-us']"
          aria-label="Learn more about our team and mission"
          class="inline-flex justify-center items-center py-2 px-4 lg:py-3 lg:px-5 sm:ms-4 text-sm lg:text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
        >
          {{ 'HOME.HERO.LEARN-MORE' | translate }}
        </a> -->
      </div>
    </div>

    <div
      id="silhouette-carousel"
      #silhouetteCarousel
      class="relative w-full z-10"
    >
      <div
        class="relative overflow-hidden rounded-lg h-36 md:h-72 xxl:h-[25rem]"
      >
        <div
          id="carousel-item-1"
          #carouselItem1
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_cologe_silhouette_442f576029.svg"
            alt="Cologe"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div
          id="carousel-item-2"
          #carouselItem2
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_berlin_silhouette_8cd4312d48.svg"
            priority
            alt="Berlin"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div
          id="carousel-item-3"
          #carouselItem3
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_dortmund_silhouette_b630f7976a.svg"
            priority
            alt="Dortmund"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div
          id="carousel-item-4"
          #carouselItem4
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_dusseldorf_silhouette_599aa367ed.svg"
            priority
            alt="Dusseldorf"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div
          id="carousel-item-5"
          #carouselItem5
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_frankfurt_silhouette_f9d9441cd5.svg"
            alt="Frankfurt"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
            loading="lazy"
          />
        </div>
        <div
          id="carousel-item-6"
          #carouselItem6
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_hamburg_silhouette_44d4d3a932.svg"
            alt="Hamburg"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
            loading="lazy"
          />
        </div>
        <div
          id="carousel-item-7"
          #carouselItem7
          class="hidden duration-[2000ms] ease-in-out"
        >
          <img
            ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/silhouetten_munich_silhouette_c5c2794ae3.svg"
            alt="Munich"
            width="2725"
            height="575"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
            loading="lazy"
          />
        </div>
      </div>
    </div>


  </div>
</section>

<section class="sm:py-24">
  <div class="flex flex-col-reverse md:flex-row" dir="ltr">
    <div class="md:w-3/5 px-8 py-4 mr-auto">
      <h1
        class="mb-4 text-3xl font-extrabold tracking-tight leading-none md:text-4xl dark:text-white"
        dir="ltr"
      >
        {{ 'HOME.ABOUT.TITLE' | translate }}
      </h1>
      <p
        class="mb-6 font-light text-gray-500 lg:mb-8 md:text-md lg:text-lg dark:text-gray-400"
        dir="ltr"
      >
        {{ 'HOME.ABOUT.DESCRIPTION' | translate }}
      </p>
      <div class="flex w-full justify-end">
        <a
          [routerLink]="['employees']"
          class="w-full sm:w-auto inline-flex justify-center items-center py-2 px-4 lg:py-3 lg:px-5 text-sm lg:text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
        >
          {{ 'HOME.ABOUT.READ-MORE' | translate }}
          <ng-icon
            name="heroArrowRightSolid"
            class="ltr:ml-2 rtl:rotate-180 rtl:mr-2"
          ></ng-icon>
        </a>
      </div>
    </div>
    <div class="flex md:w-2/5 items-center px-8 pb-8 sm:pb-0">
      <img
        src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/reichstag_md_rasmus_gundorff_saederup_a0165b5c66.webp"
        srcset="
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/reichstag_sm_rasmus_gundorff_saederup_b0f98185b8.webp  640w,
        https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/reichstag_md_rasmus_gundorff_saederup_a0165b5c66.webp  1920w
        "
        sizes="(min-width: 1920px) 688px, (min-width: 1540px) 534px,
               (min-width: 1280px) 432px, (min-width: 1040px) 330px,
               (min-width: 780px) 688px, (min-width: 680px) 560px,
               calc(94.44vw - 63px)"
        width="1920"
        height="1280"
        alt="migration"
        class="rounded-lg shadow-xl"
      />
    </div>
  </div>
</section>

<section
  class="bg-white dark:bg-gray-900 h-full py-16 -mt-16 sm:-mt-32"
  dir="ltr"
>
  <h1
    class="flex justify-center mt-16 py-6 px-2 mx-auto font-bold text-4xl text-black dark:text-white"
  >
    {{ 'HOME.INFORMATION.TITLE' | translate }}
  </h1>
  <div
    class="space-y-8 relative ml-1 md:ml-0 before:absolute before:inset-0 ltr:before:ml-5 rtl:before:mr-7 ltr:md:before:mx-auto rtl:md:before:mx-auto ltr:before:-translate-x-px rtl:before:translate-x-px md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-300 before:to-transparent"
  >
    <div
      class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
    >
      <div
        class="flex items-center justify-center w-11 h-11 rounded-full border border-white bg-slate-300 text-slate-500 group-[.is-active]:text-emerald-50 shadow shrink-0 rtl:-translate-x-[14%] md:order-1 ltr:md:group-odd:-translate-x-[40%] rtl:md:group-odd:translate-x-[44%] ltr:md:group-even:translate-x-[40%] rtl:md:group-even:-translate-x-[38%]"
      >
        <div class="job-application mt-2 w-10 h-10 text-white"></div>
        <div id="checkmark1" #checkmark1 class="wrapper">
          <svg
            [ngClass]="{ checkmark: playCheckmarkAnimation1 }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              [ngClass]="{ checkmark__circle: playCheckmarkAnimation1 }"
              class=""
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              [ngClass]="{ checkmark__check: playCheckmarkAnimation1 }"
              class=""
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>
      </div>
      <div
        class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-2xl shadow"
      >
        <div class="flex items-center justify-between space-x-2 mb-1">
          <div class="font-bold text-lg text-gray-900 dark:text-white">
            {{ 'HOME.INFORMATION.FIRST-STEP-HEADER' | translate }}
          </div>
        </div>
        <div id="ItemOneDescription" #ItemOneDescription class="text-slate-500">
          {{ 'HOME.INFORMATION.FIRST-STEP' | translate }}
        </div>
      </div>
    </div>

    <div
      class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
    >
      <div
        class="flex items-center justify-center w-11 h-11 rounded-full border border-white bg-slate-300 text-slate-500 group-[.is-active]:text-emerald-50 shadow shrink-0 rtl:-translate-x-[14%] md:order-1 ltr:md:group-odd:-translate-x-[40%] rtl:md:group-odd:translate-x-[44%] ltr:md:group-even:translate-x-[40%] rtl:md:group-even:-translate-x-[38%]"
      >
        <div class="job-interview mt-1 w-10 h-10 text-white"></div>
        <div id="checkmark2" #checkmark2 class="wrapper">
          <svg
            [ngClass]="{ checkmark: playCheckmarkAnimation2 }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              [ngClass]="{ checkmark__circle: playCheckmarkAnimation2 }"
              class=""
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              [ngClass]="{ checkmark__check: playCheckmarkAnimation2 }"
              class=""
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>
      </div>
      <div
        class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-2xl shadow"
      >
        <div class="flex items-center justify-between space-x-2 mb-1">
          <div class="font-bold text-lg text-gray-900 dark:text-white">
            {{ 'HOME.INFORMATION.SECOND-STEP-HEADER' | translate }}
          </div>
        </div>
        <div id="ItemTwoDescription" #ItemTwoDescription class="text-slate-500">
          {{ 'HOME.INFORMATION.SECOND-STEP' | translate }}
        </div>
      </div>
    </div>

    <div
      class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
    >
      <div
        class="flex items-center justify-center w-11 h-11 rounded-full border border-white bg-slate-300 text-slate-500 group-[.is-active]:text-emerald-50 shadow shrink-0 rtl:-translate-x-[14%] md:order-1 ltr:md:group-odd:-translate-x-[40%] rtl:md:group-odd:translate-x-[44%] ltr:md:group-even:translate-x-[40%] rtl:md:group-even:-translate-x-[38%]"
      >
        <div class="visa-application mt-2 w-12 h-12 text-white"></div>
        <div id="checkmark3" #checkmark3 class="wrapper">
          <svg
            [ngClass]="{ checkmark: playCheckmarkAnimation3 }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              [ngClass]="{ checkmark__circle: playCheckmarkAnimation3 }"
              class=""
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              [ngClass]="{ checkmark__check: playCheckmarkAnimation3 }"
              class=""
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>
      </div>
      <div
        class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-2xl shadow"
      >
        <div class="flex items-center justify-between space-x-2 mb-1">
          <div class="font-bold text-lg text-gray-900 dark:text-white">
            {{ 'HOME.INFORMATION.THIRD-STEP-HEADER' | translate }}
          </div>
        </div>
        <div
          id="ItemThreeDescription"
          #ItemThreeDescription
          class="text-slate-500"
        >
          {{ 'HOME.INFORMATION.THIRD-STEP' | translate }}
        </div>
      </div>
    </div>

    <div
      class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
    >
      <div
        class="flex items-center justify-center w-11 h-11 rounded-full border border-white bg-slate-300 text-slate-500 group-[.is-active]:text-emerald-50 shadow shrink-0 rtl:-translate-x-[14%] md:order-1 ltr:md:group-odd:-translate-x-[40%] rtl:md:group-odd:translate-x-[44%] ltr:md:group-even:translate-x-[40%] rtl:md:group-even:-translate-x-[38%]"
      >
        <div class="emigration-preparation mt-1 w-10 h-10 text-white"></div>
        <div id="checkmark4" #checkmark4 class="wrapper">
          <svg
            [ngClass]="{ checkmark: playCheckmarkAnimation4 }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              [ngClass]="{ checkmark__circle: playCheckmarkAnimation4 }"
              class=""
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              [ngClass]="{ checkmark__check: playCheckmarkAnimation4 }"
              class=""
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>
      </div>
      <div
        class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-2xl shadow"
      >
        <div class="flex items-center justify-between space-x-2 mb-1">
          <div class="font-bold text-lg text-gray-900 dark:text-white">
            {{ 'HOME.INFORMATION.FOURTH-STEP-HEADER' | translate }}
          </div>
        </div>
        <div
          id="ItemFourDescription"
          #ItemFourDescription
          class="text-slate-500"
        >
          {{ 'HOME.INFORMATION.FOURTH-STEP' | translate }}
        </div>
      </div>
    </div>

    <div
      class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group pt-20"
    >
      <div
        class="flex items-center justify-center w-11 h-11 rounded-full border border-white bg-slate-300 text-slate-500 group-[.is-active]:text-emerald-50 shadow shrink-0 rtl:-translate-x-[14%] md:order-1 ltr:md:group-odd:-translate-x-[40%] rtl:md:group-odd:translate-x-[44%] ltr:md:group-even:translate-x-[40%] rtl:md:group-even:-translate-x-[38%]"
      >
        <div class="plane relative w-8 h-8 rotate-[-20deg]">
          <div
            [ngClass]="{ flagAnimation: playPlaneAnimation }"
            class="german-flag absolute bottom-4 w-4 h-4 ltr:mt-1 rtl:mr-4 opacity-0"
          ></div>
        </div>
      </div>
      <div
        id="ItemFiveDescription"
        #ItemFiveDescription
        class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-2xl shadow"
      >
        <div class="flex items-center justify-between space-x-2 mb-1">
          <div class="font-bold text-lg text-gray-900 dark:text-white">
            {{ 'HOME.INFORMATION.FIFTH-STEP-HEADER' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section
  id="ourServices"
  #OurServices
  class="bg-white dark:bg-gray-900 h-full dark:text-white"
  dir="ltr"
>
  <div class="flex flex-col justify-start align-middle">
    <h1
      class="mt-16 px-6 py-4 text-center md:text-start font-bold text-4xl text-black dark:text-white"
    >
      {{ 'HOME.SERVICES.TITLE' | translate }}
    </h1>
    <p class="px-6 text-gray-500 dark:text-gray-400 text-lg">
      {{ 'HOME.SERVICES.DESCRIPTION' | translate }}
    </p>
  </div>
  <div
    class="flex flex-col md:flex-row justify-center align-middle md:px-0 text-gray-500"
  >
    <div class="flex flex-col md:flex-row gap-5 p-5 pb-12">
      <div class="md:w-2/5 flex items-center">
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/our_Services_md_scott_graham_764989f75f.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/our_Services_sm_scott_graham_9ab8bceb67.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/our_Services_md_scott_graham_764989f75f.webp  1920w
          "
          sizes="(min-width: 1920px) 683px, (min-width: 1540px) 538px, (min-width: 1280px) 443px, (min-width: 1040px) 346px, (min-width: 780px) 718px, (min-width: 680px) 590px, calc(94.44vw - 33px)"
          width="1920"
          height="1281"
          alt="Our services"
          class="rounded-lg shadow-xl"
          loading="lazy"
        />
      </div>
      <div
        class="flex flex-col gap-6 justify-start xl:gap-12 md:w-1/3 text-sm sm:text-lg lg:text-xl"
      >
        <div class="flex flex-row items-start">
          <div class="flex items-center ltr:pr-3 rtl:pl-3 sm:pt-2">
            <ng-icon
              name="bootstrapCheckCircleFill"
              class="text-blue-500"
            ></ng-icon>
          </div>
          <h1>
            {{ 'HOME.SERVICES.SERVICE-1' | translate }}
          </h1>
        </div>
        <div class="flex flex-row items-start">
          <div class="flex items-center ltr:pr-3 rtl:pl-3 sm:pt-2">
            <ng-icon
              name="bootstrapCheckCircleFill"
              class="text-blue-500"
            ></ng-icon>
          </div>
          <h1>
            {{ 'HOME.SERVICES.SERVICE-2' | translate }}
          </h1>
        </div>
        <div class="flex flex-row items-start">
          <div class="flex items-center ltr:pr-3 rtl:pl-3 sm:pt-2">
            <ng-icon
              name="bootstrapCheckCircleFill"
              class="text-blue-500"
            ></ng-icon>
          </div>
          <h1>
            {{ 'HOME.SERVICES.SERVICE-3' | translate }}
          </h1>
        </div>
      </div>
      <div
        class="flex flex-col gap-6 justify-start xl:gap-12 md:w-1/3 text-sm sm:text-lg lg:text-xl"
      >
        <div class="flex flex-row items-start">
          <div class="flex items-center ltr:pr-3 rtl:pl-3 sm:pt-2">
            <ng-icon
              name="bootstrapCheckCircleFill"
              class="text-blue-500"
            ></ng-icon>
          </div>
          <h1>
            {{ 'HOME.SERVICES.SERVICE-4' | translate }}
          </h1>
        </div>
        <div class="flex flex-row items-start">
          <div class="flex items-center ltr:pr-3 rtl:pl-3 sm:pt-2">
            <ng-icon
              name="bootstrapCheckCircleFill"
              class="text-blue-500"
            ></ng-icon>
          </div>
          <h1>
            {{ 'HOME.SERVICES.SERVICE-5' | translate }}
          </h1>
        </div>
        <div class="flex flex-row items-start justify-end">
          <a
          [routerLink]="['employees']"
          class="w-full sm:w-auto inline-flex justify-center items-center py-2 px-4 lg:py-3 lg:px-5 text-sm lg:text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
          >
            {{ 'HOME.ABOUT.READ-MORE' | translate }}
            <ng-icon
              name="heroArrowRightSolid"
              class="ltr:ml-2 rtl:rotate-180 rtl:mr-2"
            ></ng-icon>
          </a>
        </div>

      </div>
    </div>
  </div>
</section>

<section class="bg-white dark:bg-gray-900 h-full dark:text-white" dir="ltr">
  <div class="px-4 sm:px-8 py-16 mx-auto lg:py-16">
    <h1
      class="flex justify-center md:justify-start mt-16 py-6 px-2 mx-auto font-bold text-4xl text-black dark:text-white"
    >
      {{ 'HOME.JOBS.TITLE' | translate }}
    </h1>
    <div
      class="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mx-4 mb-4"
    >
      @if ((openJobs$ | async)?.length === 0) {
        <div class="col-span-full">
          <div class="flex justify-center text-gray-500 dark:text-gray-400">
            <h1 class="text-xl text-center">
              {{ 'HOME.JOBS.NO-JOBS-AVAILABLE' | translate }}
            </h1>
          </div>
        </div>
      }
      <div
        *ngFor="let job of openJobs$ | async"
        class="relative bg-white border border-gray-200 rounded-xl shadow dark:bg-gray-800 dark:border-gray-700 hover:scale-[1.005] after"
      >
        <a
          class="w-full cursor-pointer bg-green-400"
          (click)="jobSelected(job.attributes.slug)"
          [routerLink]="['jobs', 'description', job.attributes.slug]"
        >
          <div class="w-full h-28">
            <img
              class="p-4 rounded-t-lg w-full h-28 bg-contain"
              [src]="job.attributes.company_logo?.data?.attributes?.url"
              [alt]="job.attributes.company_name"
              height="112"
            />
          </div>
          <div class="p-5">
            <div class="flex flex-row">
              <h5
                class="w-full flex justify-start text-sm xxl:text-lg font-bold tracking-tight text-gray-900 dark:text-white"
              >
                {{ job.attributes.title }}
              </h5>
            </div>
            <div class="flex flex-col pt-2 pb-4">
              <div
                id="location"
                class="flex text-sm text-gray-700 dark:text-gray-400 items-center mb-2"
              >
                <ng-icon
                  name="bootstrapGeoAltFill"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ job.attributes.location }}
              </div>
              <div
                id="startDate"
                class="flex text-sm text-gray-700 dark:text-gray-400 items-center mb-2"
              >
                <ng-icon
                  name="bootstrapBriefcase"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ job.attributes.hiring_date }}
              </div>
              <div
                id="startDate"
                class="flex text-sm text-gray-700 dark:text-gray-400 items-center"
              >
                <ng-icon
                  name="bootstrapGlobe2"
                  class="ltr:mr-2 rtl:ml-2"
                ></ng-icon>
                {{ job.attributes.required_languages }}
              </div>
            </div>
            <div
              class="text-left rtl:text-right line-clamp-2 dark:text-white"
              [ngClass]="{
                'blur-text': (activeTheme$ | async) == 'light',
                'blur-text-dark': (activeTheme$ | async) == 'dark'
              }"
            >
              <div [innerHTML]="job.attributes.qualification | safeHtml"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
    @if ((openJobs$ | async)?.length != 0) {
      <div class="flex justify-end rtl:justify-start px-4">
        <button
          [routerLink]="['jobs']"
          class="w-full sm inline-flex sm:w-auto justify-center items-center py-2 px-4 lg:py-3 lg:px-5 text-sm lg:text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900"
        >
          {{ 'HOME.JOBS.MORE-JOBS' | translate }}
        </button>
      </div>
    }
  </div>
</section>
